/**
 * 是否允许取消接单（前端预检，最终以接口为准）
 * 规则：未上传简历且各阶段计数均为 0
 */
export function canCancelOrder(order = {}) {
  const peopleList = order.people_list || []
  if (peopleList.length > 0) return false

  for (let n = 1; n <= 5; n++) {
    if (+order[`status_${n}`] > 0) return false
  }
  return true
}

export function getCancelOrderTip(order = {}) {
  if (canCancelOrder(order)) return ''
  if ((order.people_list || []).length > 0) {
    return '已上传简历，无法取消接单'
  }
  return '订单已有进展，无法取消接单'
}

export function confirmGetOrder(vm, item) {
  const title = item.title ? `「${item.title}」` : '该订单'
  return vm
    .$confirm(
      `确定接单${title}？接单后可在「我的订单」中上传简历。`,
      '确认接单',
      {
        confirmButtonText: '确定接单',
        cancelButtonText: '取消',
        type: 'info',
      }
    )
    .then(() => vm.$api.index.getOrder({ id: item.id }))
}

export function confirmCancelOrder(vm, item) {
  if (!canCancelOrder(item)) {
    vm.$message.warning(getCancelOrderTip(item))
    return Promise.reject(new Error('cannot_cancel'))
  }
  const title = item.title ? `「${item.title}」` : '该订单'
  return vm.$confirm(
    `确定取消接单${title}？取消后订单将退回订单池，其他用户可再次接单。`,
    '取消接单',
    {
      confirmButtonText: '确定取消',
      cancelButtonText: '暂不取消',
      type: 'warning',
    }
  )
}
